import React from 'react';
import { GlyphDot } from '@visx/glyph';
import { Colorizers } from '@leverege/ui-attributes';
import DotGlyphModel from "../../models/glyph/DotGlyphModel.js";
export default function DotGlyphRenderer(props) {
  const {
    model,
    size: pSize,
    color,
    x,
    y,
    datum,
    context
  } = props;
  const size = DotGlyphModel.getSize(model) || pSize;
  const strokeModel = DotGlyphModel.getStroke(model);
  const fillModel = DotGlyphModel.getFill(model);
  const stroke = Colorizers.getColor(strokeModel, datum, {
    ...context,
    seriesColor: color
  }) || color;
  const fill = Colorizers.getColor(fillModel, datum, {
    ...context,
    seriesColor: color
  }) || color;
  return /*#__PURE__*/React.createElement(GlyphDot, {
    left: x,
    top: y,
    r: size / 2,
    stroke: stroke,
    fill: fill
  });
}